import esriRequest from "@arcgis/core/request.js";

const usage_Tracking=(version)=>{
    let usage_Tracking_json = `[{'attributes':{'AppName':'OCLandInsights','AppVersion':'${version}','Timestamp':" ${new Date().getTime()}"}}]`
  
      var usage_Tracking_options = {
        query: {
          f: 'json',
          adds: usage_Tracking_json
        },
        responseType: 'json',
        method: 'post'
      };

      esriRequest("https://www.ocgis.com/survey/rest/services/OCLandInsights/UsageTracking_Table/FeatureServer/3/applyEdits", usage_Tracking_options).then(function (response) {
      });

  }
export default usage_Tracking